document.addEventListener('DOMContentLoaded', () => {

  try { gsap.registerPlugin(ScrollTrigger); } catch(e) {}
  
  const MEGAMENU_EXTRA_OFFSET = -3;

  // ----- Preloader ------------------------------------------------ [ START ]
  var preloaderOverlay = document.getElementById('preloader');
  if (!preloaderOverlay) return;

  var preloaderLogo = preloaderOverlay.querySelector('.preloader__inner__logo');
  var preloaderRoot = document.documentElement;
  
  var PRELOADER_START_DELAY = 0.18;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!window.gsap || reduceMotion) {
    preloaderOverlay.style.opacity = '0';
    preloaderOverlay.style.visibility = 'hidden';
    try { preloaderOverlay.remove(); } catch(e) { preloaderOverlay.parentNode && preloaderOverlay.parentNode.removeChild(preloaderOverlay); }
    preloaderRoot.classList.remove('is-loading');
    return;
  }
  
  gsap.set(preloaderLogo, { scale: 0.5, opacity: 0.5, transformOrigin: '50% 50%' });
  gsap.set(preloaderOverlay, { autoAlpha: 1 });

  var preloaderRevealed = false;
  var preloaderFailSafe = setTimeout(runReveal, 4000);
  window.addEventListener('load', runReveal, { once: true });

  function runReveal() {
    if (preloaderRevealed) return;
    preloaderRevealed = true;
    clearTimeout(preloaderFailSafe);
    
    var tl = gsap.timeline({ delay: PRELOADER_START_DELAY, defaults: { ease: 'power2.out' } });

    tl.to(preloaderLogo, { scale: 1, opacity: 1, duration: 0.6 })
      .to(preloaderOverlay, { autoAlpha: 0, duration: 0.35 }, "+=0.15")
      .add(function() {
        try { preloaderOverlay.remove(); } catch(e) { preloaderOverlay.parentNode && preloaderOverlay.parentNode.removeChild(preloaderOverlay); }
        preloaderRoot.classList.remove('is-loading');
      });
  }
  // ----- Preloader ------------------------------------------------ [ END ]

  // ----- Sticky header ------------------------------------------------ [ START ]
  const header = document.getElementById('site-header');

  let lastScrollY = window.scrollY;

  function handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && currentScrollY > 45) {
      header.style.top = '-130px';
      header.style.opacity = '0';
      header.classList.remove('afloat');
    } else {
      header.style.top = '0';
      header.style.opacity = '1';
      header.classList.add('afloat');
    }

    if (currentScrollY < 45) {
      header.classList.remove('afloat');
    }

    lastScrollY = currentScrollY;
    
    updateMegaMenuOffset();
  }

  window.addEventListener('scroll', handleScroll);
  // ----- Sticky header ------------------------------------------------ [ END ]

  // ----- Mega Menu ------------------------------------------------ [ START ]
  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  const menu = header ? header.querySelector('.page-header__menu .main-menu') : null;
  const host = document.querySelector('.site-megamenu');
  if (!menu || !host) return;

  let isDesktop = mqDesktop.matches;
  let openId = null;
  let leaveTimer = null;
  let intentTimer = null;
  let tl;

  const originalMap = new Map();

  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const inner = document.createElement('div');
  inner.className = 'site-megamenu__container';
  host.appendChild(inner);

  const meta = document.createElement('div');
  meta.className = 'site-megamenu__container__meta is-empty';
  meta.innerHTML = `
    <h3 class="heading-2"></h3>
    <a href="" class="heading-4"></a>
  `;
  inner.appendChild(meta);
  
  function getHeaderBottomPx() {
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    return rect.bottom || 0;
  }

  function updateMegaMenuOffset() {
    host.style.position = 'fixed';
    host.style.left = '0';
    host.style.right = '0';
    host.style.width = '100%';
    host.style.zIndex = host.style.zIndex || '9999';
    
    const top = Math.max(0, getHeaderBottomPx() + MEGAMENU_EXTRA_OFFSET);
    host.style.top = `${top}px`;
  }
  
  function normalizeUrl(u) {
    if (!u) return '';
    try { return new URL(u, window.location.origin).href; }
    catch { return ''; }
  }

  function setupPanelsDesktop() {
    $$('.menu__item--has-mega', menu).forEach(li => {
      const id = li.id.replace('menu-item-', '');
      const sub = $('.sub-menu', li);
      if (!sub) return;

      if (originalMap.has(id)) return;

      const placeholder = document.createComment(`submenu-placeholder-${id}`);
      sub.before(placeholder);

      const trigger   = $('.menu__link[data-mm-target]', li);
      const mmTitle   = trigger?.getAttribute('data-mm-title') || trigger?.textContent?.trim() || '';
      const mmSub     = trigger?.getAttribute('data-mm-subheader') || '';
      const mmSubUrl  = trigger?.getAttribute('data-mm-subheader-url') || '';

      originalMap.set(id, {
        parentEl: li,
        submenuEl: sub,
        placeholder,
        meta: {
          title: mmTitle,
          subheader: mmSub,
          url: mmSubUrl
        }
      });

      const panel = document.createElement('section');
      panel.className = 'site-megamenu__container__panels';
      panel.id = `mm-${id}`;
      panel.setAttribute('role', 'region');

      const ariaLabel = (mmTitle || li.textContent || '').trim();
      panel.setAttribute('aria-label', ariaLabel);

      panel.appendChild(sub);
      inner.appendChild(panel);
    });
  }

  function teardownPanelsMobile() {
    originalMap.forEach(({ parentEl, submenuEl, placeholder }) => {
      placeholder.after(submenuEl);
    });
  }

  function animateOpen() {
    
    updateMegaMenuOffset();

    host.classList.add('is-open');
    if (tl) tl.kill();
    tl = gsap.timeline();
    tl.set(host, { visibility: 'visible' })
      .fromTo(host,
        { opacity: 0, y: -8 },
        { duration: 0.18, opacity: 1, y: 0, ease: 'power2.out' }
      );
  }

  function animateClose() {
    if (tl) tl.kill();
    tl = gsap.timeline();
    tl.to(host, {
      duration: 0.14,
      opacity: 0,
      y: -8,
      ease: 'power2.in',
      onComplete() {
        host.classList.remove('is-open');
        host.style.visibility = 'hidden';

        $$('.site-megamenu__container__panels.is-active', inner).forEach(p => p.classList.remove('is-active'));
        $$('[data-mm-target][aria-expanded="true"]', menu).forEach(a => {
          a.setAttribute('aria-expanded', 'false');
        });
        openId = null;

        const h3 = meta.querySelector('h3');
        const a  = meta.querySelector('a.heading-4');
        if (h3) h3.textContent = '';
        if (a) {
          a.textContent = '';
          a.removeAttribute('href');
          a.setAttribute('aria-disabled', 'true');
          a.classList.add('is-disabled');
        }
        meta.classList.add('is-empty');
      }
    });
  }

  function openPanel(id, triggerEl) {
    if (!isDesktop) return;
    if (openId === id) return;

    $$('.site-megamenu__container__panels.is-active', inner).forEach(p => p.classList.remove('is-active'));
    $$('[data-mm-target][aria-expanded="true"]', menu).forEach(a => a.setAttribute('aria-expanded', 'false'));

    const panel = document.getElementById(id);
    if (!panel) return;

    updateMegaMenuOffset();

    panel.classList.add('is-active');
    triggerEl?.setAttribute('aria-expanded', 'true');

    const key = id.replace('mm-', '');
    const info = originalMap.get(key) || null;
    if (info?.meta) {
      const h3 = meta.querySelector('h3');
      const a  = meta.querySelector('a');

      if (h3) h3.textContent = info.meta.title || '';

      if (a) {
        const label = info.meta.subheader || '';
        const url   = normalizeUrl(info.meta.url);
        a.textContent = label;
        if (url && label.trim().length) {
          a.setAttribute('href', url);
          a.removeAttribute('aria-disabled');
          a.classList.remove('is-disabled');
        } else {
          a.removeAttribute('href');
          a.setAttribute('aria-disabled', 'true');
          a.classList.add('is-disabled');
        }
      }

      if (info.meta.subheader && info.meta.subheader.trim().length) {
        meta.classList.remove('is-empty');
      } else {
        meta.classList.add('is-empty');
      }
    }

    if (!openId) animateOpen();
    openId = id;
  }

  function closeWithDelay() {
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(() => {
      if (!openId) return;
      animateClose();
    }, 140);
  }

  function cancelClose() {
    clearTimeout(leaveTimer);
  }

  function bindDesktopEvents() {
    $$('.menu__item--has-mega > .menu__link[data-mm-target]', menu).forEach(a => {
      a.addEventListener('mouseenter', () => {
        if (!isDesktop) return;
        clearTimeout(intentTimer);
        intentTimer = setTimeout(() => openPanel(a.getAttribute('data-mm-target'), a), 60);
      });
      a.addEventListener('focus', () => {
        if (!isDesktop) return;
        openPanel(a.getAttribute('data-mm-target'), a);
      });
      a.addEventListener('click', (e) => {
        const href = a.getAttribute('href');
        if (!href || href === '#') {
          e.preventDefault();
          openPanel(a.getAttribute('data-mm-target'), a);
        }
      });
    });

    [header, host].forEach(el => {
      el.addEventListener('mouseleave', closeWithDelay);
      el.addEventListener('mouseenter', cancelClose);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && openId) {
        animateClose();
        const opener = $(`[data-mm-target="${openId}"]`, menu);
        opener?.focus();
      }
    });

    document.addEventListener('focusin', (e) => {
      if (!openId) return;
      const withinHeader = header.contains(e.target);
      const withinHost = host.contains(e.target);
      if (!withinHeader && !withinHost) animateClose();
    });
  }

  function enableDesktop() {
    setupPanelsDesktop();
    bindDesktopEvents();
    updateMegaMenuOffset();
  }

  function disableDesktop() {
    animateClose();
    teardownPanelsMobile();
  }

  if (isDesktop) enableDesktop();

  mqDesktop.addEventListener('change', (ev) => {
    isDesktop = ev.matches;
    if (isDesktop) {
      enableDesktop();
    } else {
      disableDesktop();
    }
    updateMegaMenuOffset();
  });

  window.addEventListener('resize', updateMegaMenuOffset);
  updateMegaMenuOffset();

  try {
    const prm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (prm.matches) {
      gsap.globalTimeline.timeScale(2.5);
    }
  } catch (e) {}
  // ----- Mega Menu ------------------------------------------------ [ END ]

  // ----- Single Post ----------------------------------------------- [ START ]

  if (document.body.classList.contains('single-post')) {

    function setActiveButton(activeBtn) {
      document.querySelectorAll('.single-post__content__nav__btn').forEach((btn) => {
        btn.classList.remove('active');
      });

      if (activeBtn) {
        activeBtn.classList.add('active');
      }
    }

    document.querySelectorAll('.single-post__content__nav__btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const target = document.querySelector(btn.dataset.scrollTarget);
        if (!target) return;

        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: target,
            offsetY: 120,
          },
          ease: 'power2.out',
        });

        setActiveButton(btn);
      });
    });

    window.addEventListener('load', () => {
      setTimeout(() => {
        const sections = document.querySelectorAll('article.single-post div[id^="block-"]');

        sections.forEach((section) => {
          const sectionId = `#${section.id}`;
          const correspondingBtn = document.querySelector(
            `.single-post__content__nav__btn[data-scroll-target="${sectionId}"]`
          );

          if (!correspondingBtn || !section.id) return;

          ScrollTrigger.create({
            trigger: section,
            start: 'top center',
            end: 'bottom center',
            onEnter: () => setActiveButton(correspondingBtn),
            onEnterBack: () => setActiveButton(correspondingBtn),
            markers: false,
          });
        });

        ScrollTrigger.refresh();
      }, 300);
    });

  }

  // JS End
});

// ------------------ MOBILE MENU | -------------------------
document.addEventListener('DOMContentLoaded', () => {
  const btn  = document.querySelector('.toggle-rwd-menu');
  const menu = document.querySelector('.rwd-menu');
  if (!btn || !menu) return;

  const { gsap } = window;
  
  const tl = gsap.timeline({ paused: true })
    .fromTo(menu, { xPercent: 100, opacity: 0 }, { xPercent: 0, opacity: 1, duration: 0.35, ease: 'power2.out' }, 0);

  function collapseAllSubmenus() {
    const rows = menu.querySelectorAll('.rwd-menu__item.has-children');
    rows.forEach((li) => {
      const toggle = li.querySelector('.rwd-menu__sub-toggle');
      const sub    = li.querySelector('.rwd-menu__sub');
      if (!toggle || !sub) return;
      toggle.setAttribute('aria-expanded', 'false');
      li.setAttribute('aria-expanded', 'false');
      sub.hidden = true;
      gsap.set(sub, { height: 0 });
    });
  }

  function forceCloseMenu(skipAnim = true) {
    btn.classList.remove('active');
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('rwd-menu-open');
    menu.classList.remove('is-open');

    collapseAllSubmenus();

    if (skipAnim) {
      tl.pause(0);
      gsap.set(menu, { xPercent: 100, opacity: 0 });
    } else {
      tl.reverse(0);
    }
  }

  function openMenu() {
    menu.classList.add('is-open');
    btn.classList.add('active');
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('rwd-menu-open');
    tl.play(0);
  }

  function closeMenu() {
    tl.eventCallback('onReverseComplete', () => {
      menu.classList.remove('is-open');
    });
    tl.reverse();
    btn.classList.remove('active');
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('rwd-menu-open');
  }

  btn.addEventListener('click', () => {
    const opened = menu.classList.contains('is-open');
    opened ? closeMenu() : openMenu();
  });
  
  const rows = menu.querySelectorAll('.rwd-menu__item.has-children');
  rows.forEach((li) => {
    const toggle = li.querySelector('.rwd-menu__sub-toggle');
    const sub    = li.querySelector('.rwd-menu__sub');
    if (!toggle || !sub) return;
    
    sub.hidden = true;
    gsap.set(sub, { height: 0 });

    const collapse = () => {
      toggle.setAttribute('aria-expanded', 'false');
      li.setAttribute('aria-expanded', 'false');
      gsap.to(sub, {
        height: 0,
        duration: 0.25,
        ease: 'power1.in',
        onStart: () => { sub.hidden = false; },
        onComplete: () => { sub.hidden = true; }
      });
    };

    const expand = () => {
      toggle.setAttribute('aria-expanded', 'true');
      li.setAttribute('aria-expanded', 'true');
      sub.hidden = false;
      const h = sub.scrollHeight;
      gsap.fromTo(sub, { height: 0 }, {
        height: h,
        duration: 0.28,
        ease: 'power2.out',
        onComplete: () => gsap.set(sub, { height: 'auto' })
      });
    };

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      isOpen ? collapse() : expand();
    });
  });
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
  });
  
  window.addEventListener('pageshow', (e) => {
    forceCloseMenu(true);
  });

  window.addEventListener('pagehide', () => {
    forceCloseMenu(true);
  });

  window.addEventListener('popstate', () => {
    forceCloseMenu(true);
  });

  window.addEventListener('hashchange', () => {
    forceCloseMenu(true);
  });
});

// ------------------ SIDE NAVS -------------------------
document.addEventListener('DOMContentLoaded', () => {
  const OFFSET = 120;
  const TARGET_CLASSES = [
    '.section-meet-the-team',
    '.section-our-process',
    '.section-our-journey',
    '.section-industries',
  ];

  const upLi = document.querySelector('.site-nav .go-up');
  const downLi = document.querySelector('.site-nav .go-down');
  const upBtn = document.querySelector('.site-nav .side-nav--up');
  const downBtn = document.querySelector('.site-nav .side-nav--down');
  if (!upBtn || !downBtn) return;

  let sections = [];
  let tops = [];
  let maxScroll = 0;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  function collect() {
    sections = Array.from(document.querySelectorAll('.section'));
    tops = sections.map(s => Math.round(s.getBoundingClientRect().top + window.pageYOffset));
    maxScroll = Math.max(
      0,
      Math.round(document.documentElement.scrollHeight - window.innerHeight)
    );
  }

  function currentIndex() {
    const y = window.pageYOffset;
    let idx = 0;
    for (let i = 0; i < tops.length; i++) {
      if (tops[i] <= y + OFFSET + 1) idx = i; else break;
    }
    return idx;
  }
  function anyTargetInViewport() {
    const vh = window.innerHeight;
    for (const sel of TARGET_CLASSES) {
      const els = document.querySelectorAll(sel);
      for (const el of els) {
        const r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) return true;
      }
    }
    return false;
  }

  function updateVisibility() {
    const y = window.pageYOffset;
    const vh = window.innerHeight;
    const docH = document.documentElement.scrollHeight;

    const atAbsoluteBottom = y >= maxScroll - 1;
    const inBottomArea = y >= (docH - 1.5 * vh);
    
    const showDown = anyTargetInViewport() && !atAbsoluteBottom;
    downLi.classList.toggle('hidden', !showDown);
    downBtn.disabled = !showDown;
    
    const showUp = inBottomArea;
    upLi.classList.toggle('hidden', !showUp);
    upBtn.disabled = !showUp;
  }

  function scrollToY(target) {
    const t = clamp(Math.round(target), 0, maxScroll);
    if (window.gsap && window.ScrollToPlugin) {
      gsap.registerPlugin(ScrollToPlugin);
      gsap.to(window, { duration: 0.5, ease: 'power2.out', scrollTo: t });
    } else {
      window.scrollTo({ top: t, behavior: 'smooth' });
    }
  }

  function go(dir) {
    if (!tops.length) return;
    const idx = currentIndex();
    const nextIdx = clamp(idx + (dir > 0 ? 1 : -1), 0, tops.length - 1);
    const target = tops[nextIdx] - OFFSET;
    scrollToY(target);
  }
  
  upBtn.addEventListener('click', () => {
    scrollToY(0);
  });
  downBtn.addEventListener('click', () => go(1));

  collect();
  updateVisibility();
  
  let rAF1 = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(rAF1);
    rAF1 = requestAnimationFrame(() => {
      collect();
      updateVisibility();
    });
  });
  
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateVisibility();
      ticking = false;
    });
  }, { passive: true });
  
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(() => {
      collect();
      updateVisibility();
    });
    document.querySelectorAll('.section').forEach(s => ro.observe(s));
  }
});

// ------------------ MEET THE TEAM -------------------------
(function () {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  function anyOtherPinActive(except) {
    const all = ScrollTrigger.getAll();
    for (let i = 0; i < all.length; i++) {
      const st = all[i];
      if (st === except) continue;
      if (!st.vars) continue;
      if (!st.vars.pin) continue;
      if (st.isActive) return true;
    }
    return false;
  }

  function initMeetTheTeamPin(root = document) {
    const sections = root.querySelectorAll('.section-meet-the-team');
    if (!sections.length) return;

    const pinBySection = new WeakMap();

    const scheduleLockWidth = (el) => {
      requestAnimationFrame(() => {
        const w = el.getBoundingClientRect().width;
        if (w > 0) el.style.width = w + 'px';
      });
    };

    const makePin = (section) => {
      if (pinBySection.get(section)) return;

      const container = section.querySelector('.section-meet-the-team__tabs') || section;
      const pinTarget = section.querySelector('.tabs__nav');
      if (!container || !pinTarget) return;
      if (getComputedStyle(container).position === 'static') {
        container.style.position = 'relative';
      }

      scheduleLockWidth(pinTarget);

      const pinST = ScrollTrigger.create({
        id: 'meet-the-team-pin-' + Math.random().toString(36).slice(2),
        trigger: container,
        pin: pinTarget,
        start: 'top top+=120',
        end: 'bottom bottom-=120',
        pinSpacing: 'margin',
        pinReparent: false,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        refreshPriority: -10,
        onRefresh: () => scheduleLockWidth(pinTarget)
      });

      const imgs = section.querySelectorAll('img');
      let pending = 0;
      imgs.forEach((img) => {
        if (!img.complete) {
          pending++;
          const done = () => { if (--pending === 0) ScrollTrigger.refresh(); };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        }
      });

      pinBySection.set(section, pinST);
    };

    const killPin = (section) => {
      const st = pinBySection.get(section);
      if (!st) return;
      st.kill(true);
      pinBySection.delete(section);
      const pinTarget = section.querySelector('.tabs__nav');
      if (pinTarget) pinTarget.style.width = '';
    };

    sections.forEach((section) => {
      const guard = ScrollTrigger.create({
        trigger: section,
        start: 'top bottom-=25%',
        end: 'bottom top+=25%',
        onEnter: self => {
          if (anyOtherPinActive(null)) {
            const id = setInterval(() => {
              if (!anyOtherPinActive(null)) {
                clearInterval(id);
                if (self.isActive) makePin(section);
              }
            }, 50);
          } else {
            makePin(section);
          }
        },
        onEnterBack: self => {
          if (anyOtherPinActive(null)) {
            const id = setInterval(() => {
              if (!anyOtherPinActive(null)) {
                clearInterval(id);
                if (self.isActive) makePin(section);
              }
            }, 50);
          } else {
            makePin(section);
          }
        },

        onLeave: () => killPin(section),
        onLeaveBack: () => killPin(section)
      });

      
      ScrollTrigger.create({
        trigger: section,
        start: 'top top+=120',
        end: 'bottom top+=121',
        onUpdate(self) {
          const tooShort = self.end - self.start < 2;
          if (tooShort && guard.isActive && !pinBySection.get(section) && !anyOtherPinActive(null)) {
            makePin(section);
          }
        }
      });
    });
    
    window.addEventListener('resize', () => ScrollTrigger.refresh());
    window.addEventListener('orientationchange', () => ScrollTrigger.refresh());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMeetTheTeamPin());
  } else {
    initMeetTheTeamPin();
  }
})();